import { EmployeeRole } from '../enums/employee-role';

export const EMPLOYEE_ROLE_LEVELS: {
  level: string;
  roles: EmployeeRole[];
  hint?: string;
}[] = [
  { level: 'admin', roles: [EmployeeRole.BUSINESS_ADMIN], hint: 'includesAll' },
  {
    level: 'manager',
    roles: [EmployeeRole.MANAGER],
    hint: 'includesOperational',
  },
  {
    level: 'operational',
    roles: [
      EmployeeRole.DISPATCHER,
      EmployeeRole.PLANNER,
      EmployeeRole.FORWARDER,
      EmployeeRole.HR_AND_PAYROLL,
      EmployeeRole.TRADER,
    ],
  },
];
